import { getEndPoint } from './getEndPoint'
import { getOrphanPage } from './getOrphanPage'
import { translateCategory } from 'js/locale/localizationHelper'
export const getPageBySlug = (category, slug) => {
  if (!category) return getOrphanPage(slug)
  // do the same transformation as in the fetchData function in wpFetch.js
  let pageFolder
  switch (category) {
    case 'posts':
      pageFolder = 'blog'
      break
    case 'marketing':
      pageFolder = 'news'
      break
    default:
      pageFolder = category
  }

  const translatedCategory = translateCategory(category)
  if (!translatedCategory) {
    return Promise.reject('Page not found')
  }

  return import(
    /* webpackChunkName: "[request]" */ `wp-data/${pageFolder}/${slug}.json`
  )
    .catch(() => getEndPoint(`wp/v2/${translatedCategory}?slug=${slug}&_embed`))
    .then(json => {
      if (json.length === 0) throw new Error('Page not found')
      return json[0]
    })
}
